import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Typography, LinearProgress } from '@mui/material';
import {
  setBackButtonLabel as setBackButtonLabelAction,
  setBackButtonLinkAction,
} from '../../../redux/actions/ui';
import { ChangelogsLoader } from '../../loaders/BuildingsLoader';
import ChangesTable from './ChangesTable';

import './changelogs.css';

/**
 * Explore middle pane that shows actions that have been applied to a building
 */
const BuildingChangelog = ({
  isLoaded,
  logs,
  bid,
  building,
  setBackButtonLabel,
  setBackButtonLink,
}) => {
  useEffect(() => {
    setBackButtonLabel('< BACK TO BUILDING VIEW');
    setBackButtonLink(`/explore/buildings/${building?.name}?bid=${building?.id}`);
  });
  if (!isLoaded || !building.name)
    return (
      <div className="building-changelogs loading">
        <ChangelogsLoader buildingId={bid} />
        <LinearProgress color="secondary" />
      </div>
    );
  return (
    <div className="building-changelogs">
      <Typography variant="h4">Changelog for {building.name}</Typography>
      <div className="logs">
        {logs.length ? (
          <ChangesTable logItems={logs} />
        ) : (
          `No changes have been applied since ${building.name} was created`
        )}
      </div>
    </div>
  );
};

export default connect(
  (
    {
      entities: {
        buildings: { byId },
        buildingChangelogs: { loaded, logs },
      },
    },
    { bid }
  ) => ({
    isLoaded: loaded.has(bid),
    logs: logs[bid] || [],
    building: byId[bid] || {},
  }),
  (dispatch) => ({
    setBackButtonLabel: (label) => dispatch(setBackButtonLabelAction(label)),
    setBackButtonLink: (link) => dispatch(setBackButtonLinkAction(link)),
  })
)(BuildingChangelog);
